import polympia from './img/POlympiarenkaat.png';

export function Intro() {
  const toimikunta = [
    'Lanneluu halki',
    'Mitalilirukehä',
    'Likipinko',
    'Alaelimen hätäkännit',
    'Minieine-Henni',
    'Papin rallisanoma',
    "ann' Hennan jorata",
    'von Siviililanne',
    'Maitai-Juti',
    'Viva ällöin',
    'Erik Noir painii',
  ];

  return (
    <div className="container">
      <p className="polympia">
        <img src={polympia} alt="Polympiarenkaat" />
      </p>
      <h1 className="title">WAPUTIN 2022</h1>
      <p>
        Tervetuloa selailemaan Waputin-wappulehden digitaalista jatketta!{' '}
        <a
          href="https://www.polyteknikkojenorkesteri.fi/wappu/"
          className="mika-on-waputin"
          target="_blank"
          rel="noreferrer noopener"
        >
          (Mikä on Waputin?)
        </a>
      </p>

      <p>
        Viime vuonna syntyneen Nettiwaputtimen jalanjäljissä tänäkin vuonna on
        mahdollista e-urheilla fyysisen lipun lisäksi myös digitaalisesti.
      </p>
      <p>
        Älä kuitenkaan unohdu näyttöpäätteen ääreen, vaan saavu paikalle
        Waputin-konserttitanssiaisiin 1.5.2022 klo 17 Wanhalla Polilla (GLO
        Hotel Art, Lönnrotinkatu 29).{' '}
      </p>
      <h3>Toimikunta:</h3>
      <p>
        {toimikunta.map((x, index) => (
          <span key={x}>
            <span className="nobr">{x}</span>
            {index < toimikunta.length - 1 && ', '}
          </span>
        ))}
      </p>
    </div>
  );
}
